import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableRow } from "../table-row/TableRow";
import { TableCell } from "../table-cell/TableCell";
import { SortCell } from "../table-cell-sort/SortCell";
export const TableHead = (props) => {
    const { sort, headData = [], sortIndex, sortDirection } = props;
    return (_jsx(_Fragment, { children: headData.map((row, rowIndex) => {
            const RowComponent = row.component || TableRow;
            let columnIndex = 0;
            if (!row.id) {
                row.id = `header-row-${rowIndex}`;
            }
            return (_jsx(RowComponent, { ...row, children: row.cells &&
                    row.cells.map(({ children, ...cell }, cellIndex) => {
                        const currentColumnIndex = columnIndex;
                        const colSpanIncrement = cell.colSpan || 1;
                        columnIndex += colSpanIncrement;
                        if (!cell.id) {
                            cell.id = `${row.id}-cell-${cellIndex}`;
                        }
                        if (cell.isSortable) {
                            const isSorted = sortIndex === currentColumnIndex;
                            return (_jsx(SortCell, { isHeader: true, columnIndex: currentColumnIndex, onToggle: sort, sortDirection: isSorted ? sortDirection : "none", ...cell, children: children }, cell.id));
                        }
                        const CellComponent = cell.component ? cell.component : TableCell;
                        return (_jsx(CellComponent, { isHeader: true, ...cell, children: children }, cell.id));
                    }) }, row.id));
        }) }));
};
